<template>
  <v-card class="my-4">
    <v-card-title class="px-6 pb-0">
      <v-row>
        <v-col cols="8">
          <span class="table-card-title">Histórico de saídas do clube</span>
          <p class="section-subtitle pt-1">Essa tabela mostra o histórico de todas as solicitações de saída do clube que foram aprovadas.</p>
        </v-col>
      </v-row>
    </v-card-title>

    <paginated-data-table
      ref="table"
      :headers="headers"
      :query="query"
      queryName="deleteUserRequests"
      :queryVariables="queryVariables"
      item-key="_id"
      @update-options="updateVariables"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>
            {{ item.requested_at | date({ fmtIn: 'yyyy-MM-dd HH:mm:ss', fmtOut: 'dd/MM/yyyy | HH:mm' }) }}
          </td>
          <td>
            {{ item.finished_at | date({ fmtIn: 'yyyy-MM-dd HH:mm:ss', fmtOut: 'dd/MM/yyyy | HH:mm' }) }}
          </td>
          <td>
            {{ item.finished_by | hifen }}
          </td>
        </tr>
      </template>
    </paginated-data-table>
  </v-card>
</template>

<script>
import { QUERY_GET_DELETE_USER_REQUESTS } from '@/modules/clientes/gerenciamento/graphql'

export default {
  name: 'QuitClubRequestsHistoryTable',

  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
  },

  data() {
    return {
      queryVariables: {
        sort: ['finished_at'],
        sortDirection: ['DESC'],
      },
    }
  },

  computed: {
    query() {
      return QUERY_GET_DELETE_USER_REQUESTS
    },
    headers() {
      return [
        {
          text: 'Data da solicitação',
          value: 'requested_at',
          width: '33%',
        },
        {
          text: 'Data da resposta',
          value: 'finished_at',
          width: '33%',
        },
        {
          text: 'Respondido por',
          value: 'finished_by',
          width: '34%',
        },
      ]
    },
  },

  methods: {
    updateVariables(newQueryOptions) {
      const { sortBy, sortDesc } = newQueryOptions

      if (sortBy.length && sortDesc.length) {
        this.queryVariables.sort = sortBy
        this.queryVariables.sortDirection = sortDesc[0] ? ['DESC'] : ['ASC']
      }
    },

    updateTable() {
      this.$refs.table.waitAndGetData()
    },
  },
}
</script>

<style lang="scss" scoped>
.section-subtitle {
  @extend .texto-corrido;
  word-break: break-word;
}
</style>
